<template>
<div v-if="elements && elements.length > 0" class="nutrition-container">
  <h3 class="nutrition-table-title">{{ title }}</h3>
  <small class="disclaimer">{{ $t('recipes.lblNutritionalDisclaimer') }}</small>
  <div class="nutrition-table-block">
    <div v-if="element.label !== ''" v-for="element in elements" class="nutrition-table-items">
      <div
        :class="{
          'nutrition-table-item-with-subitems': (element.sub || []).length > 1,
          'nutrition-table-item': (element.sub || []).length < 1,
        }"
      >
        <div
          :class="{
            'nutrition-table-left-item': true,
            'nutrition-table-item-strong': element.isStrong,
          }"
        >
          {{ element.label }}
        </div>
        <div class="nutrition-table-right-item">
          {{ Math.floor(element.value || element.total || 0) + element.unit }}
        </div>
      </div>
      <div v-if="subelement.label !== ''" v-for="subelement in element.sub" class="nutrition-table-subitems">
        <div
          :class="{
            'nutrition-table-left-subitem': true,
            'nutrition-table-item-strong': subelement.isStrong,
          }"
        >
          {{ subelement.label }}
        </div>
        <div class="nutrition-table-right-subitem">
          {{ Math.floor(subelement.value || subelement.total || 0) + subelement.unit }}
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'NutritionTable',
  components: {},
  data() {
    return {};
  },
  props: {
    elements: {
      default: () => [],
      type: Array,
    },
    isEmbed: {
      type: Boolean,
    },
    title: {
      type: String,
    },
    recipeYield: {
      default: () => 1,
      type: Number,
    },
  },
  methods: {},
  computed: {},
  watch: {},
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.nutrition-table-title {
  color: $color-grey;
  font-weight: 600;
  margin-bottom: 0.4rem;
}

.disclaimer {
  color: rgba($color-darkGrey, 0.7);
  display: block;
  font-size: 1.2rem;
  line-height: 1.2;
  margin-bottom: 1.6rem;
}

.nutrition-table-block {
  background: $color-nutrition-table-block-bg;
  border: 1px solid $color-lightGrey;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.nutrition-table-items {
  border-color: $color-lightGrey;
  border-style: solid;
  border-width: 0;
  border-bottom-width: 0.1rem;
  color: #152435;
  display: flex;
  flex-direction: column;
  font-family: Helvetica, serif;
  font-size: 15px;
  letter-spacing: 0.42px;
}

.nutrition-table-item-with-subitems {
  align-items: center;
  border-color: $color-lightGrey;
  border-style: solid;
  border-width: 0;
  border-bottom-width: 0.06rem;
  display: flex;
  flex-direction: row;
  height: 3rem;
}

.nutrition-table-item {
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 3rem;
}

.nutrition-table-item-strong {
  font-weight: bold;
}

.nutrition-table-subitems {
  align-items: center;
  border-color: $color-lightGrey;
  border-style: solid;
  border-width: 0;
  border-bottom-width: $size-nutrition-table-subitems-border-width;
  display: flex;
  flex-direction: row;
  font-size: 1.6rem;
  height: 3rem;
  line-height: 2rem;
}

.nutrition-table-left-item {
  color: $color-lightGrey;
  font-size: 1.4rem;
  letter-spacing: 0.35px;
  line-height: 1.9rem;
  margin: 0.5rem auto 0.5rem 1.25rem;
}

.nutrition-table-right-item {
  color: $color-lightGrey;
  font-size: 1.4rem;
  letter-spacing: 0.35px;
  line-height: 1.9rem;
  margin-left: auto;
  margin-right: 1.25rem;
}

.nutrition-table-left-subitem {
  color: $color-lightGrey;
  font-size: 1.4rem;
  letter-spacing: 0.35px;
  line-height: 1.9rem;
  margin-left: 2.5rem;
  margin-right: auto;
}

.nutrition-table-right-subitem {
  color: $color-lightGrey;
  font-size: 1.4rem;
  letter-spacing: 0.35px;
  line-height: 1.9rem;
  margin-left: auto;
  margin-right: 1.25rem;
}
</style>
